import { createTheme } from '@mui/material'
import type {} from '@mui/x-data-grid/themeAugmentation'

// canot import rootElement from index.tsx file as it will create a dep cycle loop
const rootElement = document.getElementById('root')

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#ffffff',
    },
    error: {
      main: '#CC3333',
    },
    info: {
      main: '#0000A0',
    },
    success: {
      main: '#669966',
    },
    warning: {
      main: '#FFCC00',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          textTransform: 'none',
          color: 'white',
        },
        text: {
          fontWeight: 'bold',
          textTransform: 'none',
          color: '#0000A0',
        },
        contained: {
          fontWeight: 'bold',
          textTransform: 'none',
          color: 'white',
          backgroundColor: '#0000A0',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: { fontSize: '14px' },
        input: {
          fontSize: '14px',
          '&::placeholder': {
            opacity: 1,
            color: 'rgba(0, 0, 0, 0.6)',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '1.66',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          '& .MuiButton-root:hover': {
            color: 'black',
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          color: '#8A8A8A',
        },
        displayedRows: {
          fontWeight: 600,
        },
        // actions: {
        //   color: '#000000',
        // },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: '#c1c1c1 #f1f1f1',
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: '#f1f1f1',
            width: '9px',
            height: '9px',
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: '#c1c1c1',
            minHeight: 24,
            border: '3px solid #f1f1f1',
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus':
            {
              backgroundColor: '#999999',
            },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active':
            {
              backgroundColor: '#999999',
            },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
            {
              backgroundColor: '#999999',
            },
          '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: '#f1f1f1',
          },
        },
      },
    },
    MuiModal: {
      defaultProps: {
        container: rootElement, // so that tailwind css would be applied, as by default it renders outside the root container
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeaders: {
          backgroundColor: '#F8F8F8',
        },
        columnHeader: {
          backgroundColor: '#F8F8F8',
          outline: 'transparent',
          ':focus-within': {
            outline: 'none',
          },
          ':focus': {
            outline: 'none',
          },
        },
        cell: {
          outline: 'transparent',
          ':focus-within': {
            outline: 'none',
          },
          ':focus': {
            outline: 'none',
          },
        },
        // 'cell--editing': {
        //   outline: 'transparent',
        //   ':focus-within': {
        //     outline: 'none',
        //   },
        //   ':focus': {
        //     outline: 'none',
        //   },
        // },
        columnHeaderTitle: {
          color: '#666666',
          fontWeight: '700',
          whiteSpace: 'break-spaces',
          lineHeight: 1,
        },
        row: {
          ':hover': { backgroundColor: 'unset' },
        },
        columnHeaderTitleContainer: {
          fontSize: '12px',
        },
      },
    },
  },
})
